export const REVIEW_SEARCH_FIELDS = [
  "reviewer_name",
  "body",
  "platform",
  "rating",
  "searchable_attribution",
];
